var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, customElement, html, LitElement, property } from 'lit-element';
import i18n from 'roddeh-i18n';
import './tc-autocomplete';
import TcaiSuggestions from '../services/suggestions/tcai-suggestions';
import NativeSuggestions from '../services/suggestions/native-suggestions';
let SearchBox = class SearchBox extends LitElement {
    static get styles() {
        return css `
            * {
                box-sizing: border-box;
            }
            .container {
                max-width: 27rem;
                margin: auto;
            }

            .container.always-visible {
                max-width: initial;
            }

            .container form {
                position: relative;
                display: block;
            }

            .container input {
                color: var(--color-primary);
                border: none;
                background: #ffffff;
                border-radius: 0;
                height: 3.2em;
                width: 100%;
                padding: 0 2.5em 0 2.5em;
                font-size: 1em;
                font-weight: 500;
                border-bottom: 1px solid var(--color-primary);
            }

            .container input::placeholder {
                color: var(--color-primary);
            }

            .container input:focus-visible,
            .container input:focus {
                outline: none;
                box-shadow: none;
                border: none;
                border-bottom: 1px solid var(--color-primary);
            }

            .container button.delete-search-button {
                opacity: 0;
                background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNSIgaGVpZ2h0PSIzNSI+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMjUuMTc0IDguMzQyYTEuMTY2IDEuMTY2IDAgMTExLjY1IDEuNjVMMTkuNCAxNy40MTZsNy40MjUgNy40MjVhMS4xNjYgMS4xNjYgMCAxMS0xLjY1IDEuNjVsLTcuNDI1LTcuNDI1LTcuNDI0IDcuNDI1YTEuMTY2IDEuMTY2IDAgMDEtMS41NDguMDlsLS4xMDItLjA5YTEuMTY2IDEuMTY2IDAgMDEwLTEuNjVsNy40MjQtNy40MjUtNy40MjQtNy40MjRhMS4xNjYgMS4xNjYgMCAxMTEuNjUtMS42NWw3LjQyNCA3LjQyNHoiLz48L3N2Zz4=);
                background-repeat: no-repeat;
                background-position: 50%;
                background-size: 24px auto;
                position: absolute;
                top: 50%;
                height: 2em;
                width: 2em;
                padding: 7px;
                right: 0.1em;
                border: 0;
                outline: 0 none;
                transform: translateY(-50%);
                margin-right: 0;
                background-color: #ececec;
                border-radius: 100% !important;
                cursor: pointer;
                transition: opacity 100ms ease-in-out;
            }

            .container button.delete-search-button.active {
                opacity: 1;
            }

            .container button.search-button {
                position: absolute;
                background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOS43MTkgMTcuOTQ0Ij48ZyBmaWxsPSJub25lIiBzdHJva2U9IiMxNDM2MTYiIHN0cm9rZS13aWR0aD0iMS41Ij48cGF0aCBkPSJNNC40MzUgNS41MThhNS43MzcgNS43MzcgMCAwMTguMDE0LTEuMDU2IDUuNjY0IDUuNjY0IDAgMDExLjA2NCA3Ljk3IDUuNzM3IDUuNzM3IDAgMDEtOC4wMTQgMS4wNTcgNS42NjQgNS42NjQgMCAwMS0xLjA2NC03Ljk3eiIgc3Ryb2tlLXdpZHRoPSIxLjUwMDA3NTAwMDAwMDAwMDMiLz48cGF0aCBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgZD0iTTE0LjEwOCAxMi41MTNsNC42MjkgMy41MjMiLz48L2c+PC9zdmc+);
                background-repeat: no-repeat;
                background-position: 50%;
                background-size: 24px auto;
                border: 0;
                top: 50%;
                left: 0.22em;
                cursor: pointer;
                z-index: 2;
                width: 20px;
                height: 20px;
                outline: 0 none;
                background-color: transparent;
                color: transparent;
                text-align: center;
                text-shadow: none;
                transform: translateY(-50%);
            }

            @media (max-width: 1000px) {
                .container button.delete-search-button {
                    margin-right: 0.5em;
                }
                .container input {
                    font-size: 16px;
                }
            }
        `;
    }
    constructor() {
        super();
        this.action = '';
        this.productSearchRequest = null;
        this.tcaiEnabled = false;
        this.persooEnabled = false;
        this.deleteButtonActive = false;
        this.autoCompleteOffset = 0;
        this.phrase = '';
        this.correctedPhrase = '';
        this.hintsEnabled = false;
        this.loading = false;
        this.hintsOpen = false;
        this.hints = {
            phrase: { suggestions: [], meta: null },
            category: { suggestions: [], meta: null },
            product: { suggestions: [], meta: null },
        };
        this.debounceTimeout = null;
        if (typeof window.__STATE__ !== 'undefined') {
            this.tcaiEnabled = window.__STATE__.functions.tcai_enabled;
            this.persooEnabled = window.__STATE__.functions.persoo_enabled;
            this.hintsEnabled = window.__STATE__.functions.search_hints_enabled;
        }
    }
    connectedCallback() {
        super.connectedCallback();
        if (!this.persooEnabled) {
            this.mobileSearchListener();
        }
        this.outOfTheComponentClickListener();
    }
    firstUpdated() {
        this.setAutocompleteOffset();
        this.onWindowResize();
        window.addEventListener('toggle-mobile-top-menu', (e) => {
            const shadowRoot = this.shadowRoot;
            if (!shadowRoot) {
                return;
            }
            const container = shadowRoot.querySelector('.container');
            if (!container) {
                return;
            }
            const searchWrapper = document.querySelector('header > .search');
            if (!searchWrapper) {
                return;
            }
            if (e.detail.visible) {
                if (searchWrapper.classList.contains('always-visible')) {
                    searchWrapper.classList.remove('always-visible');
                }
                if (container.classList.contains('always-visible')) {
                    container.classList.remove('always-visible');
                }
            }
        });
    }
    render() {
        return html `
            <div class="container search-box">
                <form
                    action="${this.getActionUrl().toString()}"
                    method="get"
                    @submit="${(e) => this.onSubmit(e)}"
                >
                    <input
                        type="text"
                        @focusin=${() => this.onInputFocusIn()}
                        @input=${(e) => this.onInputChange(e)}
                        autocomplete="off"
                        placeholder="${i18n('Product name or reference...')}"
                        id="search-input"
                        name="q"
                    />
                    ${this.productSearchRequest && this.productSearchRequest.availableInPos === true
            ? html ` <input type="hidden" name="is" value="1" /> `
            : ''}
                    ${this.productSearchRequest && this.productSearchRequest.pos
            ? html ` <input type="hidden" name="shop" value="${this.productSearchRequest.pos.id}" /> `
            : ''}
                    <button class="search-button" title="${i18n('Search')}"></button>
                    <button
                        class="delete-search-button ${this.deleteButtonActive ? 'active' : ''}"
                        title="${i18n('Search')}"
                        @click=${(e) => {
            e.preventDefault();
            this.clearInput(true);
            this.requestUpdate().catch((err) => console.error('Failed to update', err));
        }}
                    ></button>
                </form>
                ${this.hintsEnabled
            ? html `
                          <tc-autocomplete
                              ?open="${this.hintsOpen}"
                              .lastPhrases="${this.getLastPhrases()}"
                              .productSearchRequest="${this.productSearchRequest}"
                              phrase="${this.phrase}"
                              correctedPhrase="${this.correctedPhrase}"
                              .hints="${this.hints}"
                              .searchUrl="${this.getActionUrl()}"
                              style="top: ${this.autoCompleteOffset}px"
                              @change-phrase="${this.changeInputPhrase}"
                          ></tc-autocomplete>
                      `
            : ''}
            </div>
        `;
    }
    onSubmit(e) {
        e.preventDefault();
        const target = e.target;
        const input = this.getInputElement();
        if (!input) {
            return;
        }
        if (input.value === '') {
            return;
        }
        this.setLastPhrase(input.value);
        target.submit();
    }
    setLastPhrase(phrase) {
        if (phrase === '' || phrase === null) {
            return;
        }
        if (typeof localStorage === 'undefined' || localStorage === null) {
            return;
        }
        const lastPhrases = localStorage.getItem('lastSearchPhrases');
        if (lastPhrases) {
            const phrases = lastPhrases.split(',');
            if (phrases.length > 5) {
                phrases.pop();
            }
            if (!phrases.includes(phrase)) {
                phrases.unshift(phrase);
            }
            else {
                const index = phrases.indexOf(phrase);
                phrases.splice(index, 1);
                phrases.unshift(phrase);
            }
            localStorage.setItem('lastSearchPhrases', phrases.join(','));
        }
        else {
            localStorage.setItem('lastSearchPhrases', phrase);
        }
    }
    getLastPhrases() {
        if (typeof localStorage === 'undefined' || localStorage === null) {
            return [];
        }
        const lastPhrases = localStorage.getItem('lastSearchPhrases');
        if (lastPhrases) {
            return lastPhrases.split(',');
        }
        return [];
    }
    onInputChange(e) {
        if (this.debounceTimeout) {
            clearTimeout(this.debounceTimeout);
        }
        const target = e.target;
        this.debounceTimeout = setTimeout(() => {
            if (target.value === '') {
                this.clearInput();
            }
            else {
                this.deleteButtonActive = true;
                if (target.value !== '') {
                    this.getHints(target.value);
                }
            }
            this.requestUpdate().catch((err) => console.error('Failed to update', err));
        }, 250);
    }
    onInputFocusIn() {
        this.showHints();
        this.requestUpdate().catch((err) => console.error('Failed to update', err));
    }
    getHints(phrase) {
        if (!this.hintsEnabled) {
            return;
        }
        this.loading = true;
        this.correctedPhrase = '';
        let suggestionsService;
        if (this.tcaiEnabled) {
            suggestionsService = new TcaiSuggestions();
        }
        else {
            suggestionsService = new NativeSuggestions();
        }
        suggestionsService
            .getSuggestions(phrase)
            .then((suggestions) => {
            const input = this.getInputElement();
            if (input && input.value != '') {
                if (suggestions) {
                    this.hints = suggestions;
                    this.correctedPhrase = suggestions.product.meta?.correctedPhrase ?? '';
                }
                else {
                    this.hints = {
                        phrase: { suggestions: [], meta: null },
                        category: { suggestions: [], meta: null },
                        product: { suggestions: [], meta: null },
                    };
                }
                this.phrase = phrase;
                this.showHints();
            }
            else {
                this.hideHints();
            }
            this.loading = false;
        })
            .catch((err) => {
            console.error('Failed to get suggestions', err);
            this.loading = false;
        })
            .finally(() => {
            this.requestUpdate().catch((err) => console.error('Failed to update', err));
        });
    }
    clearInput(hideHints = false) {
        const input = this.getInputElement();
        if (!input) {
            return;
        }
        input.value = '';
        this.phrase = '';
        this.deleteButtonActive = false;
        if (hideHints) {
            this.hideHints();
        }
    }
    getInputElement() {
        const shadowRoot = this.shadowRoot;
        if (!shadowRoot) {
            return null;
        }
        return shadowRoot?.querySelector('input[type="text"]');
    }
    hideHints() {
        this.hints = {
            phrase: { suggestions: [], meta: null },
            category: { suggestions: [], meta: null },
            product: { suggestions: [], meta: null },
        };
        this.setBodyOverflowHidden();
        this.hintsOpen = false;
    }
    showHints() {
        if (!this.hintsEnabled) {
            return;
        }
        this.setBodyOverflowHidden();
        this.setAutocompleteOffset();
        this.hintsOpen = true;
    }
    getViewPortWidth() {
        return Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    }
    outOfTheComponentClickListener() {
        // nasłuchuj kliknięcie w dowolne miejsce na stronie poza:
        // formularzem wyszukiwania, tc-autocomplete oraz elementem header
        document.addEventListener('click', (e) => {
            const target = e.target;
            if (target.nodeName === 'SEARCH-BOX' ||
                target.nodeName === 'HEADER' ||
                target.parentElement?.nodeName === 'HEADER') {
                return;
            }
            this.clearInput(true);
            this.requestUpdate().catch((err) => console.error('Failed to update', err));
        });
    }
    mobileSearchListener() {
        const searchActivate = document.querySelector('header > .search-activate');
        if (!searchActivate) {
            return;
        }
        searchActivate.addEventListener('click', (e) => {
            e.preventDefault();
            this.toggleMobileSearchInput();
        });
    }
    toggleMobileSearchInput() {
        const shadowRoot = this.shadowRoot;
        if (!shadowRoot) {
            return;
        }
        const container = shadowRoot.querySelector('.container');
        if (!container) {
            return;
        }
        const searchWrapper = document.querySelector('header > .search');
        if (!searchWrapper) {
            return;
        }
        searchWrapper.classList.toggle('always-visible');
        container.classList.toggle('always-visible');
        const visible = container.classList.contains('always-visible');
        const event = new CustomEvent('toggle-mobile-search', {
            detail: { visible },
            bubbles: true,
        });
        window.dispatchEvent(event);
        if (visible) {
            const input = container.querySelector('input');
            if (!input) {
                return;
            }
            input.focus();
        }
    }
    setBodyOverflowHidden() {
        if (!this.hintsEnabled) {
            return;
        }
        if (this.getViewPortWidth() <= 820 && this.hintsOpen && this.phrase !== '') {
            // Dodaj style overflow hidden do body
            document.body.classList.add('disable-scroll');
        }
        else {
            document.body.classList.remove('disable-scroll');
        }
    }
    setAutocompleteOffset() {
        if (!this.hintsEnabled) {
            return;
        }
        const searchBox = document.querySelector('body > header search-box');
        if (!searchBox) {
            return;
        }
        const header = document.querySelector('body > header');
        if (!header) {
            return;
        }
        const search = document.querySelector('body > header div.search');
        if (!search) {
            return;
        }
        // pobierz wysokosc elementu header
        const headerHeight = header.getBoundingClientRect().height;
        const searchHeight = search.getBoundingClientRect().height;
        this.autoCompleteOffset = this.getViewPortWidth() <= 1000 ? searchHeight : headerHeight;
    }
    onWindowResize() {
        window.addEventListener('resize', () => {
            this.setAutocompleteOffset();
            this.setBodyOverflowHidden();
            if (this.hintsOpen) {
                this.shadowRoot?.querySelector('.container')?.classList.add('always-visible');
                document.querySelector('header > .search')?.classList.add('always-visible');
            }
            this.requestUpdate().catch((err) => console.error('Failed to update', err));
        });
    }
    getActionUrl() {
        return new URL(this.action, window.location.toString());
    }
    changeInputPhrase(changePhraseEvent) {
        if (typeof changePhraseEvent.detail !== 'string') {
            return;
        }
        const searchInput = this.shadowRoot?.querySelector('#search-input');
        if (!searchInput) {
            return;
        }
        searchInput.value = changePhraseEvent.detail;
        const event = new Event('input', {
            bubbles: true,
            cancelable: true,
        });
        searchInput.dispatchEvent(event);
    }
};
__decorate([
    property({ type: String })
], SearchBox.prototype, "action", void 0);
__decorate([
    property({ type: Object })
], SearchBox.prototype, "productSearchRequest", void 0);
SearchBox = __decorate([
    customElement('search-box')
], SearchBox);
export default SearchBox;
